module.exports = __webpack_public_path__ + "img/sdyj.93e55139.png";